<template>
    <el-dialog :visible="localVisible" title="New address for cha ron (czp2250@outlook.com)" width="600px"
        :before-close="closeDialog" class="responsive-dialog">
        <!-- Address Form -->
        <el-form ref="addressForm" :model="addressForm" label-width="120px" class="address-form">

            <div class="form-row">
                <el-form-item label="Street Address (Line 1)">
                    <el-input v-model="addressForm.line_1" placeholder="Street Address"></el-input>
                </el-form-item>
            </div>

            <el-form-item label="Street Address (Line 2)">
                <el-input v-model="addressForm.line_2" placeholder="House/Apartment Number"></el-input>
            </el-form-item>

            <el-form-item label="Country">
                <el-select v-model="addressForm.country" @change="fetchStates">
                    <el-option v-for="country in countries" :key="country.code" :label="country.name"
                        :value="country.code">
                    </el-option>
                </el-select>
            </el-form-item>

            <div class="form-row">
                <el-form-item label="City">
                    <el-input v-model="addressForm.city" placeholder="City"></el-input>
                </el-form-item>
                <el-form-item label="State">
                    <el-select v-model="addressForm.state">
                        <el-option v-for="state in states" :key="state.code" :label="state.name" :value="state.code">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>

            <el-form-item label="Postal code">
                <el-input v-model="addressForm.postal_code" placeholder="Postal Code"></el-input>
            </el-form-item>

            <!-- Address Type (Billing or Shipping) -->
            <el-form-item label="Address Type">
                <el-select v-model="addressForm.type">
                    <el-option label="Billing" value="billing"></el-option>
                    <el-option label="Shipping" value="shipping"></el-option>
                </el-select>
            </el-form-item>

            <!-- Default Address -->
            <el-form-item label="Set as Default Address">
                <el-switch v-model="addressForm.default_address"></el-switch>
            </el-form-item>

        </el-form>

        <!-- Dialog Footer -->
        <div class="dialog-footer">
            <el-button @click="closeDialog">Discard</el-button>
            <el-button type="primary" :disabled="!isFormValid" @click="submitAddress">Create Address</el-button>
        </div>
    </el-dialog>
</template>

<script>
import axios from "axios";

export default {
    name: "AddAddressModal",
    props: {
        visible: Boolean, // Read-only prop
        existingAddress: Object, // Address data for editing
    },
    data() {
        return {
            localVisible: this.visible, // Use a local copy
            addressForm: { // Form model
                line_1: "", // Street address
                line_2: "", // House/Apartment number
                country: "", // Country code
                state: "", // State code
                city: "", // City code
                postal_code: "", // Postal code
                type: "billing", // Default address type
                default_address: false, // Whether this is the default address
            },
            countries: [], // To store country options
            states: [], // To store state/province options
        };
    },
    watch: {
        visible(val) {
            this.localVisible = val;
            if (!val) {
                this.resetForm(); // 当弹窗关闭时，清空表单
            }
        },
        existingAddress: {
            immediate: true,
            handler(newAddress) {
                if (newAddress) {
                    // 设置表单数据为现有地址数据
                    this.addressForm = { ...newAddress };
                }
            }
        }
    },
    computed: {
        isFormValid() {
            return (
                this.addressForm.line_1 &&
                this.addressForm.city &&
                this.addressForm.postal_code &&
                this.addressForm.type // Ensure address type is selected
            );
        },
    },
    mounted() {
        this.fetchCountries();
    },
    methods: {
        resetForm() {
            // 清空表单数据
            this.addressForm = {
                line_1: "", // Street address
                line_2: "", // House/Apartment number
                country: "", // Country code
                state: "", // State code
                city: "", // City code
                postal_code: "", // Postal code
                type: "billing", // Default address type
                default_address: false, // Whether this is the default address
            };
        },
        closeDialog() {
            this.$emit("update:visible", false); // Notify parent to close modal
        },

        submitAddress() {
            this.$emit("addressCreated", { ...this.addressForm });
            this.closeDialog();
        },
        async fetchCountries() {
            try {
                const res = await axios.get("https://lazidev.futong.online/json/country-state.json");
                this.countries = res.data.data.map(country => ({ name: country.name, code: country.code }));
                this.fetchStates(); // Fetch states for the selected country
            } catch (error) {
                console.error("Error fetching countries:", error);
            }
        },
        async fetchStates() {
            try {
                const res = await axios.get("https://lazidev.futong.online/json/country-state.json");
                const countryData = res.data.data.find(country => country.code === this.addressForm.country);
                if (countryData) {
                    this.states = countryData.states;
                }
            } catch (error) {
                console.error("Error fetching states:", error);
            }
        }
    }
};
</script>

<style scoped>
/* Responsive Dialog */

/* Form Layout */
.address-form {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

/* Two-column layout for larger screens */
.form-row {
    display: flex;
    gap: 10px;
}

.form-row .el-form-item {
    flex: 1;
}

/* Responsive Design */
@media (max-width: 728px) {
    .form-row {
        flex-direction: column;
        gap: 5px;
    }

    .responsive-dialog {
        max-width: auto;
    }
}

/* Dialog Footer */
.dialog-footer {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}
</style>
